<!-- 흐름 분석 뷰 컴포넌트 -->
<template>
    <div class="flow-chart-view" style="height: 50rem">
        <div v-if="!isEmpty(sumNodeFlowData)" style="height: 100%; width: 100%">
            <FlowChartPanel :data="sumNodeFlowData" :phscPointUsageMap="phscPointUsageMap" />
        </div>
        <div
            v-else
            class="empty-state"
            style="
                height: 100%;
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
            "
        >
            <span class="detail-notification-icon">
                <i class="fas fa-exclamation-circle"></i>
            </span>
            <span class="detail-notification-text">표시할 데이터가 없습니다.</span>
        </div>
    </div>
</template>

<script>
import FlowChartPanel from "../../panel/FlowChartPanel.vue";

export default {
    name: "FlowChartView",
    components: {
        FlowChartPanel,
    },
    props: {
        sumNodeFlowData: {
            type: Object,
            default: null,
        },
        phscPointUsageMap: {
            type: Map,
            default: () => new Map(),
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../styles/common/_detail-common.scss";

.flow-chart-view {
    /* 스타일은 필요시 추가 */
}
</style>
